import React, { Component } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import { Autoplay, Navigation } from "swiper/modules";

import banner2 from "../../../assests/img/banner2.png";
import banner4 from "../../../assests/img/banner4.png";
import banner5 from "../../../assests/img/banner5.png";
import banner7 from "../../../assests/img/banner7.png";

import { Card, Col, Row } from "react-bootstrap";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";

class SliderSec extends Component {
  render() {
    return (
      <>
        {/* ================= SLIDER SECTION ================= */}
        <section className="slider_sec">
          <Swiper
            modules={[Navigation, Autoplay]}
            loop={true}
            navigation={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            slidesPerView={1}
            spaceBetween={20}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className="frame_img">
                <img
                  src={banner2}
                  alt="Kior Healthcare diagnostic centre in Punjab"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="frame_img">
                <img
                  src={banner4}
                  alt="Advanced imaging and radiology services in Punjab"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="frame_img">
                <img
                  src={banner5}
                  alt="Fully automated pathology lab in Punjab"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="frame_img">
                <img
                  src={banner7}
                  alt="CT scan and X-ray diagnostic services in Punjab"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>
          </Swiper>
        </section>

        {/* ================= INTRO TEXT ================= */}
        <section className="home_intro_text">
          <div className="coustom_container">
            <h1>
              Kior Healthcare – Your Trusted <span>Diagnostic Centre</span> in
              Punjab
            </h1>

            <h2>
              Accurate Results • Advanced Technology • Complete Diagnostic Care
            </h2>

            <p>
              Kior Healthcare is the best diagnostic centre in Punjab offering
              credible, economical, and patient-centric diagnostic services.
              With advanced imaging systems, a fully automated pathology lab,
              and a skilled medical team, we deliver accurate testing and faster
              reports for every patient.
            </p>

            <p>
              Our mission is to make diagnostics accessible, precise, and
              trustworthy across Punjab.
            </p>
          </div>
        </section>

        {/* ================= CARD SECTION ================= */}
        {/* <section className="card_sec">
          <div className="coustom_container">
            <Row>
              <Col lg={6} md={6} sm={12}>
                <Card>
                  <Card.Body>
                    <Card.Title>Browse Our Full Test Menu</Card.Title>
                    <Card.Text>
                      Explore a wide range of pathology and radiology tests
                      designed to meet all your healthcare needs.
                    </Card.Text>
                    <div className="card_btn">
                      <a
                        href="https://play.google.com/store/search?q=kior+healthcare&c=apps&hl=en"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Buy Now <NavigateNextOutlinedIcon />
                      </a>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              <Col lg={6} md={6} sm={12}>
                <Card>
                  <Card.Body>
                    <Card.Title>Download Our Mobile App</Card.Title>
                    <Card.Text>
                      Book tests, access reports, and manage your diagnostics
                      conveniently through our mobile application.
                    </Card.Text>
                    <div className="card_btn">
                      <a
                        href="https://play.google.com/store/search?q=kior+healthcare&c=apps&hl=en"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Buy Now <NavigateNextOutlinedIcon />
                      </a>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </section> */}

        {/* ================= PATHOLOGY & IMAGING INFO ================= */}
        <section className="service_info">
          <div className="coustom_container">
            <div className="service_block">
              <h2>Comprehensive Care Pathology Lab in Mohali</h2>
              <p>
                Our modern <strong>care pathology lab in Mohali</strong> offers
                a wide spectrum of blood tests, preventive health packages,
                wellness panels, and specialized diagnostic profiles.
              </p>

              <p className="sub_title">Our pathology services include:</p>
              <ul>
                <li>Routine blood investigations</li>
                <li>Thyroid, liver, kidney, and diabetes profiles</li>
                <li>Hormone panels</li>
                <li>Cancer screening</li>
                <li>Senior citizen health packages</li>
                <li>Pregnancy & antenatal testing</li>
                <li>Full-body checkups</li>
              </ul>

              <p>
                All tests are processed using advanced laboratory equipment to
                ensure accuracy, reliability, and timely reporting.
              </p>
            </div>

            <div className="service_block">
              <h2>Advanced Imaging Center for Accurate Diagnostics</h2>
              <p>
                As a trusted <strong>imaging center in Punjab</strong>, Kior
                Healthcare provides high-quality imaging services that support
                accurate diagnosis and confident clinical decisions.
              </p>

              <p className="sub_title">Our imaging services include:</p>
              <ul>
                <li>X-Ray scanning</li>
                <li>CT Scan services</li>
                <li>Ultrasound imaging</li>
                <li>Digital radiology</li>
              </ul>

              <p>
                Our experienced professionals ensure patient comfort, safety,
                and clarity of results at every step.
              </p>
            </div>

            <div className="service_cta">
              <h3>Book Your Test Today</h3>

              <p>
                Choose Kior Healthcare — your trusted diagnostic centre in
                Punjab, with a state-of-the-art pathology lab in Mohali and a
                modern imaging center for X-Ray, CT Scan, and more.
              </p>

              <p className="cta_links">
                <a href="tel:+91 8263000004">Call Now</a>
                <span className="divider"> | </span>

                <a
                  href="https://play.google.com/store/search?q=kior+healthcare&c=apps&hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Book Online
                </a>
                <span className="divider"> | </span>

                <a href="/contact-us">Visit Our Centre</a>
              </p>

              <p className="cta_note">
                Your health begins with accurate diagnosis — we are here to
                support you at every step.
              </p>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default SliderSec;
